import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoonUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2868_9052)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.8252 3.17574C16.0595 2.94142 16.4395 2.94142 16.6738 3.17574L19.5908 6.09175C19.8251 6.32604 19.825 6.70607 19.5908 6.94038C19.3565 7.17467 18.9765 7.17465 18.7422 6.94038L16.8545 5.05269V10.0175C16.8543 10.3487 16.5861 10.6171 16.2549 10.6171C15.9236 10.6171 15.6555 10.3487 15.6553 10.0175V5.04097L13.7568 6.94038C13.5226 7.17454 13.1435 7.17453 12.9092 6.94038C12.6749 6.70608 12.6749 6.32607 12.9092 6.09175L15.8252 3.17574Z",
				fill: "#DFCBF5",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 16.25,
				cy: 24.8671,
				rx: 11.25,
				ry: 11.25,
				fill: "url(#paint0_linear_2868_9052)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.2451 13.6171C22.4589 13.6171 27.4961 18.6535 27.4961 24.8661C27.4961 31.0787 22.4589 36.1152 16.2451 36.1152C14.2344 36.1152 12.3484 35.585 10.7148 34.6611C11.3296 34.7793 11.964 34.8437 12.6133 34.8437C18.1361 34.8437 22.6133 30.3665 22.6133 24.8437C22.6133 19.3209 18.1361 14.8437 12.6133 14.8437C12.0034 14.8437 11.4069 14.9012 10.8271 15.0058C12.4344 14.1211 14.2808 13.6171 16.2451 13.6171Z",
				fill: "url(#paint1_linear_2868_9052)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2868_9052",
			x1: 16.25,
			y1: 14.2549,
			x2: 16.25,
			y2: 36.0653,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9565FD",
				stopOpacity: .2
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2868_9052",
			x1: 10.6269,
			y1: 24.8672,
			x2: 27.5027,
			y2: 24.8672,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#9565FD"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2868_9052",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 24,
				fill: "white"
			})
		})
	] })]
});
export default SvgMoonUp;
